import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import "../../Components/PreOrderTicketCard/TicketCard.css";
import { FiArrowRight } from "react-icons/fi";
import pingleLogo from "../../Assets/Images/pingle.png";
import vegIcon from "../../Assets/Images/vegpngoutput.png"
import nonvegIcon from "../../Assets/Images/nomvegoutput.png"
import eggIcon from "../../Assets/Images/eggpngoutput.png"

export default function Kitchen_membership_card({ Data, pageName }) {

  const DEFAULT_Ticket_IMAGE_URL =
    "https://theme-assets.getbento.com/sensei/6941e9b.sensei/assets/images/catering-item-placeholder-704x520.png";
  const DEFAULT_IMAGE_URL =
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcScO99JkPvdfSyT3CbMrYsKBpRuXOACVR2cP9F6DBcP9B6nQ9oszX_18T-2oNv6Gyxwyhk&usqp=CAU";

  const { vendor_id } = useParams();
  const textRef = useRef(null);
  const [lineWidth, setLineWidth] = useState(0);
  const [data, setData] = useState(Data);
  const navigate = useNavigate();
  const [showContainer, setShowContainer] = useState(true);

  useEffect(() => {
    if (textRef.current) {
      setLineWidth(textRef.current.offsetWidth);
    }
  }, [data.ticket_name]);

  const [timeLeft, setTimeLeft] = useState({
    minutes: 0,
    seconds: 0,
    expired: false
  });

  const [status, setStatus] = useState("before");


  const MEAL_START_TIME = {
    1: "06:00",
    2: "17:00",
    3: "12:00",
    4: "15:00",
    5: "18:00",
    6: "22:00",
  };


  // 3️⃣ HELPERS
  const getBookingWindow = (meal_time, book_before_time) => {
    const start = MEAL_START_TIME[meal_time];
    if (!start) return null;

    const [h, m] = start.split(":").map(Number);

    const mealStart = new Date();
    mealStart.setHours(h, m, 0, 0);

    const bookingClose = new Date(mealStart);
    bookingClose.setHours(
      bookingClose.getHours() - Number(book_before_time)
    );

    const bookingStart = new Date(bookingClose);
    bookingStart.setHours(bookingStart.getHours() - 1);

    return { bookingStart, bookingClose };
  };


  const getRemainingTime = (endTime) => {
    const diff = endTime - new Date();

    if (diff <= 0) {
      return { minutes: 0, seconds: 0, expired: true };
    }

    const totalSeconds = Math.floor(diff / 1000);

    return {
      minutes: Math.floor(totalSeconds / 60),
      seconds: totalSeconds % 60,
      expired: false
    };
  };


  useEffect(() => {
    if (!data?.meal_time || !data?.book_before_time) return;

    const window = getBookingWindow(
      data.meal_time,
      data.book_before_time
    );

    if (!window) return;

    const interval = setInterval(() => {
      const now = new Date();

      if (now < window.bookingStart) {
        setStatus("before");
      }
      else if (now >= window.bookingClose) {
        setStatus("closed");
        setTimeLeft({ minutes: 0, seconds: 0, expired: true });
        clearInterval(interval);
      }
      else {
        setStatus("active");
        setTimeLeft(getRemainingTime(window.bookingClose));
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [data?.meal_time, data?.book_before_time]);


  return (
    <div className={`card-main-box-container  mt-2 mb-3 `}>
      {showContainer ?
        <div
          className={`kitchenMembershipCard ${data?.card_pattern ? "ImageDesign" : ""
            }`}
          style={{
            background: data?.card_pattern
              ? `url(${data.card_pattern})`
              : data?.ticket_card_color && data.ticket_card_color !== "transparent"
                ? data.ticket_card_color
                : "rgb(231, 52, 96)",
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >


          <div className="membership-card-image-container">
            <img src={`https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${data?.ticket_image || DEFAULT_Ticket_IMAGE_URL}`}
              alt="Preview" className="membership-card-image" onError={(e) => { e.target.onerror = null; e.target.src = DEFAULT_Ticket_IMAGE_URL; }} />
          </div>
          <div className="conatiner-right-Card">
            <div className="content-top p-0 d-flex justify-content-between align-items-center">

              <div className="store-name p-0 text-white">

                <div className="fs-14 ff-poppins-semiBold">
                  {data?.hub_name}
                </div>
                <div className="fs-9 ff-poppins-medium">
                  ({data?.vendor_company_name})
                </div>

              </div>
              <button className="flip_btn ff-poppins-medium col-4 rounded-3 p-1" onClick={() => setShowContainer(!showContainer)}>Flip</button>
            </div>
            <div className="content-bottom mt-1">
              <div  >
                <div className="d-flex">
                  {data?.ticket_type &&
                    <img src={data?.ticket_type == "1" ? vegIcon : data?.ticket_type == "2" ? nonvegIcon : data?.ticket_type == "3" ? eggIcon : ""}
                      height="13px" width="13px" className="me-1   " />
                  }
                  <div ref={textRef} className="fs-11 ff-poppins-semiBold text-uppercase text-white"   >
                    {data?.ticket_name || "TICKET NAME"}
                  </div>
                </div>
                <div className="gradient-line"  ></div>
              </div>
              <p className="content ff-poppins-medium fs-10 text-white">
                {(
                  data?.about_ticket ||
                  "This ticket is for food, making preordering easy, convenient, budget..."
                ).slice(0, 70) + (data?.about_ticket?.length > 70 ? "..." : "")}
              </p>
              <div className="d-flex justify-content-between">
                <div className="price fs-12 ff-poppins-semiBold text-white">
                  <span className="rupeeIcon "> ₹</span>{data?.ticket_price || "00.0"} {" "}
                  / {data?.validity_count_days}{data?.membership_validity_type == 0 ? 'Days' : 'Month'}

                </div>
                {data?.quantity == 1 &&
                  <span className="price fs-12 ff-poppins-medium text-white">
                    Available :  {data.quantity_count}
                  </span>}
              </div>
            </div>

            <div className={`d-flex ${status == "active" ? 'justify-content-between' : ' justify-content-end'}  `}>

              {status === "active" && (
                <div className="membershipDeadline">
                  <span className="fs-12 ff-poppins-medium text-white">
                    Deadline :
                  </span>
                  <span className="membershipDeadlineLable">
                    {String(timeLeft.minutes).padStart(2, "0")}:
                    {String(timeLeft.seconds).padStart(2, "0")}
                  </span>
                </div>
              )}



              <div className="cardRightAlign"
                onClick={() =>
                  navigate(`/food-membership-detail/${data.vendor_id}/${data.membership_ticket_id}`)}  >
                {pageName == "listScreen" || pageName == "mymembershiplist" ? (
                  <span className="d-flex align-items-center">
                    Buy Now <FiArrowRight className="ms-1" />
                  </span>
                ) : (
                  "Subscription"
                )}
              </div>

            </div>
          </div>

        </div>
        :
        <div>

          <div className={`kitchen-membership-card ${data?.card_pattern ? "ImageDesign" : ""}`}
            style={{
              background: data?.card_pattern ? `url(${data.card_pattern})` : data?.ticket_card_color && data.ticket_card_color != "transparent" ? data.ticket_card_color : "rgb(231, 52, 96)",
              backgroundSize: "cover", backgroundPosition: "center", backgroundRepeat: "no-repeat",
            }} >
            <div className="conatiner-right-Card">
              <div className="content-top p-0 d-flex justify-content-between align-items-center">
                <div className="d-flex">
                  {data?.food_type &&
                    <img src={data?.food_type == "1" ? vegIcon : data?.food_type == "2" ? nonvegIcon : data?.food_type == "3" ? eggIcon : ""}
                      height="13px" width="13px" className="me-1 mt-1" />
                  }


                  <div className="store-name p-0 text-white">
                    <div className="fs-14 ff-poppins-semiBold">
                      {data?.hub_name}
                    </div>
                    <div className="fs-9 ff-poppins-medium">
                      ({data?.vendor_company_name})
                    </div>
                  </div>

                </div>
                <button className="flip_btn ff-poppins-medium col-3 rounded-3 p-1" onClick={() => setShowContainer(!showContainer)}>Flip</button>
              </div>
              <div className="content-bottom mt-1">
                <div>
                  <div className="fs-15 d-flex justify-content-center ff-poppins-semiBold text-uppercase text-white"   >
                    {data.membership_ticket_id || data?.ticket_id}
                  </div>
                  <span className=" fs-12 ms-5 ps-5 m-0 ff-poppins-medium text-white d-flex justify-content-center">
                    Ticket Id
                  </span>
                </div>
              </div>

              <div className="preOrder-bottom-container">
                <div className="logo d-flex">
                  <img className="bottom-right" src={pingleLogo} width={"100%"} height={"100%"} />
                </div>
              </div>
            </div>


            {/* <div className="conatiner-center p-1">
              <div className="content-top ">
                <div>
                  <img src={data?.food_type === "1" ? vegIcon : data?.food_type === "2" ? nonvegIcon : data?.food_type === "3" ? eggIcon : ""}
                    height="13" width="13" className="me-1" alt="" />
                  <div className="store-name p-0 text-white">
                    <div className="fs-14 ff-poppins-semiBold">
                      {data?.hub_name}
                    </div>
                    <div className="fs-9 ff-poppins-medium">
                      ({data?.vendor_company_name})
                    </div>
                  </div>
                </div>
                <button className="flip_btn ff-poppins-medium col-3 rounded-3 p-1" onClick={() => setShowContainer(true)}>Flip</button>
              </div>

              <div className="left">
                <span className="px-4 fs-14 ff-poppins-semiBold text-uppercase text-white text-left">
                  {data.ticket_name}
                </span>
              </div>
              <div className="text-center">
                <div>
                  <span className="content-right ff-poppins-bold fs-19 text-white">
                    {data.ticket_id}
                  </span> <br></br>
                  <span className=" fs-12 p-0 m-0 ff-poppins-regular text-white">
                    Ticket Id
                  </span>
                </div>
              </div>
              <div className="preOrder-bottom-container">

                <div className="logo d-flex">
                  <img className="bottom-right" src={pingleLogo} width={"100%"} height={"100%"} />
                </div>
              </div>
            </div> */}
          </div>
        </div>
      }
    </div>
    // <div>
    //   <section className="section-spaces">
    //     <div className="kitchen-membershipDetail-card group">
    //       <div className="kitchen-membership-image-wrapper">
    //         <img src={data?.ticket_image
    //           ? `https://pingle.s3.ap-south-1.amazonaws.com/uploads/kitchen/kitchen_products/${data?.ticket_image}`
    //           : DEFAULT_Ticket_IMAGE_URL}
    //           alt="Chicken Biryani"
    //           className="kitchen-membership-image"
    //         />

    //         <div className="kitchen-membership-overlay" ></div>

    //         <div className="kitchen-membership-content">
    //           <h2 className="kitchen-membershipDetail-title">
    //             {data?.ticket_name}
    //           </h2>
    //           <p className="kitchen-membership-desc">
    //             {data?.about_ticket}
    //           </p>
    //         </div>
    //         {/* <div className="kitchen-membership-footer">
    //           <span className="kitchen-membership-card-price">
    //             <span className="rupeeIcon">₹</span>{data?.ticket_price}
    //           </span>
    //           <button className="kitchen-membership-btn" onClick={() => navigate(`/food-membership-detail/${data.vendor_id}/${item.membership_ticket_id}`)}> Buy now </button>
    //         </div> */}
    //       </div>
    //     </div>
    //   </section>
    // </div>
  );
}
